import { render } from "./timesheet-approval.html?vue&type=template&id=20134d2e&scoped=true&ts=true&external"
import script from "./timesheet-approval.ts?vue&type=script&lang=ts&external"
export * from "./timesheet-approval.ts?vue&type=script&lang=ts&external"

import "./timesheet-approval.scss?vue&type=style&index=0&id=20134d2e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20134d2e"]])

export default __exports__